import { createLazyComponent } from '../shared/createLazyComponent';

// The legacy tree as its own chunk, loaded when the drawer first opens — the same treatment
// the consolidated Shell gets, and for the same reason: `magic-apron-legacy` drags Apollo and
// the package's entire UI with it, and most page loads never open the drawer. Neither tree is
// on the warm-while-closed path, and only the one behind the active flag is ever fetched.
//
// The importer lives HERE, inside the directory it loads, so retiring the tree is a directory
// delete plus the App edit — not a hunt for importers that outlived their target.
export const LazyLegacyApp = createLazyComponent(
  () => import('./LegacyApp'),
  'LegacyApp',
  { label: 'Legacy Assistant', rethrowOnError: true },
);
